export const isMpPending = (order) => {
    const method = String(order?.paymentMethod || "")
        .toLowerCase()
        .replace(/\s+/g, ""); // "Mercado Pago" -> "mercadopago", "mercadoPago" -> "mercadopago"
    const status = String(order?.paymentStatus || "").toLowerCase();
    return (method === "mercadopago" || method === "mp") && status === "pendiente";
};